export const eventKeyTab = 'Tab';
export const eventKeyEscape = 'Escape';
export const eventKeyUp = 'ArrowUp';
export const eventKeyDown = 'ArrowDown';
export const eventKeyEnter = 'Enter';
export const eventKeyNumpadEnter = 'NumpadEnter';
export const eventKeySpace = 'Space';
export const eventKeyShift = 'Shift';
